export default "__VITE_ASSET___Yyd2pHI__"